module.exports = __webpack_public_path__ + "img/about_1979.449c8855.png";